module.exports = __webpack_public_path__ + "templates/home.html";


//////////////////
// WEBPACK FOOTER
// ./src/app/common/templates/home.html
// module id = Vy3d
// module chunks = 1